import { Button } from "@unified-checkout/design-system";
import type { IFormIntro } from "@app/dashboard/types/outerLayout/common";
import { isXpenceUser } from "@app/dashboard/utils/isXpenceUser";
import XpenceLogo from '@app/dashboard/assets/images/outerLayout/xpence-logo.png';
import styles from "./form-intro.module.scss";

const FormIntro = ({
  heading,
  formLegend,
  subtitle,
  children,
  backBtnProps
}: IFormIntro) => {
  return (
    <div className={styles['form-intro']}>
      {heading}

      <form className={styles['form-intro__form']} onSubmit={(e) => { e.preventDefault() }}>
        {backBtnProps && <Button {...backBtnProps} />}

        <div className={styles['form-intro__form__header']}>

          {formLegend && <legend>{formLegend}</legend>}

          {isXpenceUser() && <img src={XpenceLogo} alt="Xpence logo" />}

          {subtitle && <p className={styles['form-intro__form__header__desc']}>{subtitle}</p>}

        </div>

        {children}
      </form>
    </div>
  )
}

export default FormIntro;